import gql from 'graphql-tag';

const DELETE_USER = gql`
    mutation deleteUser ($email: String) {
        deleteUser(email: $email) {
        result
        }
    }
`;

export default DELETE_USER;
